import { Select } from "components/UI/Select/SelectComponent";
import {
  getSecureValidation,
  hideErrorModal,
  setSelectItems,
  updateSelectValue,
} from "containers/TransferSubscriptions/store/ActionCreators";
import { get, isNil } from "lodash";
import * as React from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { CONFRONTA_TRANSLATION_CODES } from "root/shared/BankCatalogEnum";
import {
  catalog_cities_co,
  catalog_departments_co,
} from "root/shared/Catalog/CountryCatalog";
import { CajitaStore, ISelectProps } from "root/store/CajitaStore";
import {
  ISelectItem,
  ITransferSubscriptionFormProps,
} from "types/cajita_store";
import { Category } from "types/category";
import { ITransferSubscriptionActionCreator } from "types/transfer_subscription_action_creator";

export interface IConfrontaAnswer {
  answer: string;
  id: string;
}

interface IConfrontaState {
  openModal: boolean;
  hideConfirmConfrontaValidation: boolean;
  hideDocumentValidation: boolean;
  hideQuestions: boolean;
  hideFooterLogo: boolean;
  hideFooterNumber: boolean;
  questionNumber: number;
  questionResponse: IConfrontaAnswer[];
  date: string;
  waitingQuestions: boolean;
  showAdviceModal: boolean;
}

/**
 * Confronta validation Component
 */
class ConfrontaValidationComponent extends React.Component<
  ITransferSubscriptionFormProps,
  IConfrontaState
> {
  private documentValidationClasses: string = "col-4 text-right";
  private _questionsLength: string = "questions.length";
  private _divideModal: string = "divide-modal";

  constructor(props: ITransferSubscriptionFormProps) {
    super(props);
    this._selectHandler = this._selectHandler.bind(this);
    this.state = {
      openModal: true,
      hideConfirmConfrontaValidation: false,
      hideDocumentValidation: true,
      hideQuestions: true,
      hideFooterLogo: true,
      hideFooterNumber: true,
      questionNumber: 1,
      questionResponse: [],
      date: "02/02/2020",
      waitingQuestions: false,
      showAdviceModal: false,
    };
  }

  public componentDidMount(): void {
    this.props.setSelectItems(
      get(this.props, "departmentSelect.id"),
      ConfrontaValidationComponent._getDepartments()
    );
    this.props.setSelectItems(get(this.props, "citySelect.id"), [
      { value: "CFT002", text: "Seleccione su ciudad..." },
    ]);
  }

  public componentDidUpdate(): void {
    if (!isNil(this.props.secureValidationError)) {
      setTimeout((): void => this.props.hideErrorModal(), 5000);
      setTimeout((): void => {
        this.setState({
          openModal: false,
        });
      }, 2000);
    }

    return;
  }

  private static _capitalize(text: string): string {
    return text.charAt(0).toUpperCase() + text.toLowerCase().slice(1);
  }

  // tslint:disable-next-line:max-func-body-length
  public render(): React.ReactNode {
    return (
      <Modal
        isOpen={Boolean(this.props.openModal) && this.state.openModal}
        className={"modal-confronta"}
      >
        <ModalHeader style={{ border: "none" }}>
          <Container fluid={true}>
            <Row>
              <Col xs={6} className={"confronta-main-label"}>
                <span>
                  <Translate id="dataVerificationLabel" />
                </span>
              </Col>
              <Col xs={6} className={"confronta-about-box"}>
                <div
                  id={"confronta-about"}
                  className={"confront-about-box-label"}
                  onClick={(): void => {
                    this._showAdviceModal();
                  }}
                >
                  <span>
                    <Translate id="howItWorks" />
                  </span>
                </div>
              </Col>
            </Row>
          </Container>
        </ModalHeader>
        <ModalBody>
          <Alert
            color="danger"
            className={"otpErrorMessage"}
            isOpen={!isNil(this.props.secureValidationError)}
          >
            {this.props.secureValidationError}
          </Alert>
          <div
            className={"ConfirmConfrontaValidation"}
            hidden={this.state.hideConfirmConfrontaValidation}
          >
            {this.state.showAdviceModal ? (
              <div className={"help-modal"}>
                <Row>
                  <Col xs={12}>
                    <div style={{ textAlign: "end", cursor: "pointer" }}>
                      <span
                        id={"confronta-about-close"}
                        onClick={(): void => {
                          this._showAdviceModal();
                        }}
                      >
                        x
                      </span>
                    </div>
                  </Col>
                  <Col xs={12}>
                    <div>
                      <p>
                        <Translate id={"howItWorksMessage"} />
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            ) : null}
            <Container className={"center-modal "}>
              <Row style={{ height: "100%" }}>
                <Col xs={12}>
                  <p className={"title-alert"}>
                    <Translate id="waitMoment" />
                  </p>
                  <p className={"description-alert"}>
                    <Translate id="confrontaDescription" />
                    <b>
                      {" "}
                      <Translate id="confrontaDescriptionStrong" />
                    </b>
                  </p>
                </Col>
                <Col xs={12} style={{ margin: "auto" }}>
                  <Button
                    color="primary"
                    className="confirm-button confirmCodeButton"
                    onClick={(): void => this._confirmConfrontaCheck()}
                  >
                    <Translate id="confirmButtonText" />
                  </Button>
                  <br />
                  <div style={{ paddingTop: 10 }}>
                    <Button
                      className="confronta-reject-button"
                      onClick={
                        // istanbul ignore next
                        (): void => {
                          this.setState({
                            openModal: !this.state.openModal,
                          });
                        }
                      }
                    >
                      <Translate id="cancelButtonText" />
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          <div
            className={"DocumentValidation"}
            hidden={this.state.hideDocumentValidation}
          >
            <Container className={this._divideModal}>
              <div style={{ textAlign: "left", paddingBottom: 16 }}>
                <span>
                  <Translate id={"adviceDocumentNumber"} />
                </span>
              </div>
              <div style={{ paddingBottom: 23 }}>
                <span className={"document-number"}>
                  {this.props.documentNumber.value}
                </span>
              </div>
              <Form>
                <Row>
                  <Col xs={12} style={{ paddingBottom: 19 }}>
                    <span
                      className="pse-label toggle-left transfer-subscription-account-label"
                      style={{ marginBottom: 3 }}
                    >
                      <Translate id="expeditionDateLabel" />
                    </span>
                    <Input
                      placeholder="Date"
                      type={"date"}
                      className={"input-width"}
                      onChange={(e: { target: { value: string } }): void =>
                        this._onDateChange(`${e.target.value}`)
                      }
                    />
                  </Col>
                  <Col xs={12} style={{ paddingBottom: 19 }}>
                    <span
                      className="pse-label toggle-left transfer-subscription-account-label"
                      style={{ marginBottom: 3 }}
                    >
                      <Translate id="departmentLabel" />
                    </span>
                    <Select
                      translationTargets={CONFRONTA_TRANSLATION_CODES}
                      {...this.props.departmentSelect}
                      change={this._selectHandler}
                    />
                  </Col>
                  <Col xs={12}>
                    <span
                      className="pse-label toggle-left transfer-subscription-account-label"
                      style={{ marginBottom: 3 }}
                    >
                      <Translate id="cityLabel" />
                    </span>
                    <Select
                      translationTargets={CONFRONTA_TRANSLATION_CODES}
                      {...this.props.citySelect}
                      change={this._selectHandler}
                    />
                  </Col>
                  <Col xs={12} style={{ margin: "auto", paddingTop: 16 }}>
                    <Button
                      id={"confirm-secure-validation-button"}
                      color="primary"
                      className="confirm-button confirmCodeButton"
                      onClick={(): void => this._sendSecureValidationRequest()}
                    >
                      <Translate id={"continueButtonText"} />
                    </Button>
                    <br />
                    <div style={{ paddingTop: 10 }}>
                      <Button
                        className="confronta-reject-button"
                        onClick={
                          // istanbul ignore next
                          (): void => this._returnConfrontaCheck()
                        }
                      >
                        <Translate id="cancelButtonText" />
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Container>
          </div>
          <div
            className={"Questions"}
            hidden={
              this.state.hideQuestions && !Boolean(this.props.questionReceived)
            }
          >
            {this.props.questions !== undefined
              ? this.props.questions.map(
                  (
                    question: {
                      text: string;
                      options: {
                        id: string;
                        text: string;
                      }[];
                      id: string;
                    },
                    index: number
                  ): React.ReactNode => (
                    <div
                      className={this._divideModal}
                      hidden={index + 1 !== this.state.questionNumber}
                    >
                      <Container>
                        <Row>
                          <Col xs={12}>
                            <div
                              className={"title-alert title-confronta-question"}
                            >
                              {ConfrontaValidationComponent._capitalize(
                                question.text
                              )}{" "}
                              :
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            className={"confronta-counter-questions"}
                          >
                            <div>
                              {this.state.questionNumber}/
                              {get(this.props, this._questionsLength)}
                            </div>
                          </Col>
                        </Row>
                        <br />
                        {question.options.map(
                          (option: {
                            id: string;
                            text: string;
                          }): React.ReactNode => (
                            <div>
                              <Button
                                color="info"
                                className={`${
                                  option.text
                                } max-width-button confront-button-question`}
                                onClick={(): void =>
                                  this.confirmQuestions(question.id, option.id)
                                }
                              >
                                {" "}
                                {ConfrontaValidationComponent._capitalize(
                                  option.text
                                )}{" "}
                              </Button>
                              <br />
                              <br />
                            </div>
                          )
                        )}
                      </Container>
                    </div>
                  )
                )
              : null}
          </div>
        </ModalBody>
        <ModalFooter>
          <div
            hidden={this.state.hideFooterLogo}
            className={"col-10 verifiedBy-right"}
          />
        </ModalFooter>
      </Modal>
    );
  }

  private confirmQuestions(questionId: string, answer: string): void {
    // istanbul ignore else
    if (this.state.questionNumber === get(this.props, this._questionsLength)) {
      this.setState({
        ...this.state,
        questionNumber: this.state.questionNumber,
        questionResponse: [
          {
            answer,
            id: questionId,
          },
        ].concat(this.state.questionResponse),
      });
      this._sendSecureValidationAnswers();
    } else
      this.setState({
        ...this.state,
        questionNumber:
          this.state.questionNumber === get(this.props, this._questionsLength)
            ? this.state.questionNumber
            : this.state.questionNumber + 1,
        questionResponse: [
          {
            answer,
            id: questionId,
          },
        ].concat(this.state.questionResponse),
      });

    return;
  }

  private _confirmConfrontaCheck(): void {
    this.setState({
      ...this.state,
      hideQuestions: true,
      hideFooterLogo: false,
      hideFooterNumber: true,
      hideConfirmConfrontaValidation: true,
      hideDocumentValidation: false,
    });
  }

  private _showAdviceModal(): void {
    this.setState({
      showAdviceModal: !this.state.showAdviceModal,
    });
  }

  // istanbul ignore next
  private _returnConfrontaCheck(): void {
    this.setState({
      ...this.state,
      hideQuestions: true,
      hideFooterLogo: true,
      hideFooterNumber: true,
      hideConfirmConfrontaValidation: false,
      hideDocumentValidation: true,
    });
  }

  private _onDateChange(e: string): void {
    this.setState({
      ...this.state,
      date: e.replace("-", "/").replace("-", "/"),
    });
  }

  private _selectHandler(id: string, newValue: string): void {
    const new_select: ISelectProps = { ...this.props[id] };

    new_select.value = newValue;
    this.props.setSelectItems(
      get(this.props, "citySelect.id"),
      ConfrontaValidationComponent._getCities(newValue)
    );
    this.props.onSelectChanged(new_select);
  }

  // istanbul ignore next
  private _confirmDocumentCheck(): void {
    this.setState({
      ...this.state,
      hideQuestions: false,
      hideFooterLogo: false,
      hideFooterNumber: false,
      hideConfirmConfrontaValidation: true,
      hideDocumentValidation: true,
    });
  }

  private static _getCities(department: string): ISelectItem[] {
    return [{ value: "CFT002", text: "Seleccione su ciudad" }].concat(
      catalog_cities_co.filter(
        (catalog: Category) => catalog.main === department
      ) as ISelectItem[]
    );
  }

  private static _getDepartments(): ISelectItem[] {
    return [{ value: "CFT001", text: "Seleccione su departamento..." }].concat(
      catalog_departments_co as ISelectItem[]
    );
  }

  private _sendSecureValidationRequest(): void {
    this.props.getSecureValidationQuestions(
      this.props.citySelect.value,
      this.props.departmentSelect.value,
      this.state.date,
      this.props.secureServiceId,
      this.props.secureService
    );
    this.setState({
      ...this.state,
      hideQuestions: false,
      hideFooterLogo: false,
      hideFooterNumber: false,
      hideConfirmConfrontaValidation: true,
      hideDocumentValidation: true,
      waitingQuestions: true,
    });

    return;
  }

  private _sendSecureValidationAnswers(): void {
    this.props.sendSecureValidationResponse(
      this.props.secureServiceId,
      this.props.secureService,
      this.state.questionResponse,
      this.props.questionnaireCode
    );
  }
}

// istanbul ignore next
const mapStateToProps: (
  state: CajitaStore
) => ITransferSubscriptionFormProps = (
  state: CajitaStore
): ITransferSubscriptionFormProps => ({
  ...state.transferSubscriptions,
});

// istanbul ignore next
const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<
    CajitaStore,
    undefined,
    ITransferSubscriptionActionCreator
  >
): object => ({
  getSecureValidationQuestions: (
    cityCode: string,
    stateCode: string,
    expeditionDate: string,
    secureServiceId: string,
    secureService: string
  ): void =>
    dispatch(
      getSecureValidation(
        secureServiceId,
        secureService,
        cityCode,
        stateCode,
        expeditionDate
      )
    ),
  onSelectChanged: (payload: ISelectProps): void =>
    dispatch(updateSelectValue(payload)),
  setSelectItems: (id: string, items: ISelectItem[]): void =>
    dispatch(setSelectItems(id, items)),
  hideErrorModal: (): void => dispatch(hideErrorModal()),
  sendSecureValidationResponse: (
    secureServiceId: string,
    secureService: string,
    answers: IConfrontaAnswer[],
    questionnaireCode: string
  ): void =>
    dispatch(
      getSecureValidation(
        secureServiceId,
        secureService,
        undefined,
        undefined,
        undefined,
        answers,
        questionnaireCode
      )
    ),
});

const ConfrontaValidation: React.ComponentClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfrontaValidationComponent);

export { ConfrontaValidation };



// WEBPACK FOOTER //
// ./src/components/WaitingView/ConfrontaValidationComponent.tsx